import { useContext } from 'react'

import { RequestProfileTabInternalTasksContext } from '../../RequestProfileTabInternalTasks.context'

export function useRequestProfileTabInternalTasksContext() {
  return useContext(RequestProfileTabInternalTasksContext)
}
